<template>
<div class="body">
  <her2/>

</div>
</template>

<script>
import her2 from './components/her2.vue'
export default {
  name: 'App',
  components: {
    her2,
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/App.vue